// extracted by extract-css-chunks-webpack-plugin
module.exports = {"topicTitle":"topicTitle-105yeXyn","titleLogo":"titleLogo-QtGXFQA7","titleTxt":"titleTxt-ZNqwkPEX"};